import { FETCH_MontantInvest_REQUEST, FETCH_MontantInvest_SUCCESS, FETCH_MontantInvest_FAILURE } from './actionsTypes';

export const fetchMontantInvestRequest = (token,history) => ({
  type: FETCH_MontantInvest_REQUEST,
  payload: { token,history },
});

export const fetchMontantInvestSuccess = (montantInvestData) => ({
  type: FETCH_MontantInvest_SUCCESS,
  payload: { montantInvestData },
});

export const fetchMontantInvestFailure = (error) => ({
  type: FETCH_MontantInvest_FAILURE,
  payload: { error },
});

